<div class="flex-column gap wrapper">
    <div class="flex flex-1 align-items-center justify-content-between">
        <div class="flex gap">
            @if (sickNoteId()) {
                <app-switch-input [form]="form" id="correctiveFilling" [prefix]="prefix"></app-switch-input>
            }
            <div class="text-danger">{{ errorMessage() }}</div>
        </div>

        <div class="flex gap">
            <app-text-input [form]="form" id="decisionNumber" [prefix]="prefix" [readonly]="true"></app-text-input>
            <app-select-input [form]="form" id="sszCode" [prefix]="prefix"
                [infiniteScroll]="this.store.sszRegionScroll"
                filterBy="code,name"
                [valueKey]="'code'"
                [idField]="'code'"
            ></app-select-input>
        </div>
    </div>

    <div class="input-grid-gaps grid-2col">
        <!--    left-->
        <div class="input-grid-gaps grid-6col container">
            <label class="font-bold fr-6">{{ 'sickNotes.detail.labels.insuredPerson' | translate }}</label>

            <app-text-input class="fr-2" [form]="form" id="surname"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>
            <app-text-input class="fr-2" [form]="form" id="name"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>
            <app-text-input class="fr-2" [form]="form" id="titles"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>

            <app-date-input class="fr-2" [form]="form" id="birthDate"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>
            <app-text-input class="fr-2" [form]="form" id="insuranceNumber"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>

            <hr class="fr-6">

            <label class="font-bold fr-6">{{ 'sickNotes.detail.labels.address' | translate }}</label>

            <app-address-input class="fr-6" [form]="form" id="address"
                [disabled]="finalFilled()"></app-address-input>
            <app-text-input class="fr-2" [form]="form" id="phone"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>
            <app-text-input class="fr-2" [form]="form" id="email"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>
            <app-text-input class="fr-2" [form]="form" id="addition"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>

            <hr class="fr-6">

            <label class="font-bold fr-6">{{ 'sickNotes.detail.labels.employmentNameAddress' | translate }}</label>

            <app-text-input class="fr-4" [form]="form" id="employerName"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>
            <div class="fr-2 flex gap-small">
                <app-text-input class="fr-2" [form]="form" id="profession"
                    [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>
                <app-button
                    pTooltip="{{ 'sickNotes.detail.tooltip.saveProfession' | translate }}"
                    icon="pi-save"
                    (clickEvent)="saveProfession()"
                ></app-button>
            </div>

            <app-address-input class="fr-6" [form]="form" id="employerAddress"
                [disabled]="finalFilled()"></app-address-input>

            <hr class="fr-6">

            <label class="font-bold fr-6">{{ 'sickNotes.detail.labels.allowedWalkouts' | translate }}</label>

            <app-date-input class="fr-2" [form]="form" id="walkoutsFromDate" [showTime]="false"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>
            <!--            TODO: min 9:00 max 17:00-->
            <app-date-input [form]="form" id="walkoutsFrom1" [timeOnly]="true"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>
            <app-date-input [form]="form" id="walkoutsTo1" [timeOnly]="true"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>
            <app-date-input [form]="form" id="walkoutsFrom2" [timeOnly]="true"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>
            <app-date-input [form]="form" id="walkoutsTo2" [timeOnly]="true"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>

            <hr class="fr-6">

            <app-radio-input class="fr-6" [form]="form" id="insuranceAdministrator" layout="vertical" [columns]="2"
                [staticOptions]="csszInsuranceAdministratorEnumOptions" [autoSelectFirst]="true"
                [disabled]="finalFilled()"
            ></app-radio-input>
        </div>

        <!--    right-->
        <div class="input-grid-gaps grid-6col container">
            <label
                class="font-bold fr-6">{{ 'sickNotes.detail.labels.temporaryIncapacityForWorkInfo' | translate }}</label>

            <app-diagnosis-select-input
                class="fr-2"
                [form]="form"
                id="diagnosisCode"
                [label]="prefix + 'fields.diagnosisCode'"
                [disabled]="finalFilled()"
            ></app-diagnosis-select-input>

            <app-date-input class="fr-2" [form]="form" id="incapacityStartDate" [showTime]="false"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>
            <app-date-input class="fr-2" [form]="form" id="issueDate" [showTime]="false"
                [disabled]="finalFilled()" [prefix]="prefix"></app-date-input>

            <app-check-input class="fr-3" [form]="form" id="injury"
                [disabled]="finalFilled()" [prefix]="prefix"></app-check-input>
            <app-check-input class="fr-3" [form]="form" id="workInjury"
                [disabled]="finalFilled()" [prefix]="prefix"></app-check-input>

            <app-check-input class="fr-3" [form]="form" id="injuryFromAnotherPerson"
                [disabled]="finalFilled()" [prefix]="prefix"></app-check-input>
            <app-check-input class="fr-3" [form]="form" id="usingAlcoholOrDrugs"
                [disabled]="finalFilled()" [prefix]="prefix"></app-check-input>

            <app-text-input class="fr-6" [form]="form" id="doctorOrigin"
                [disabled]="finalFilled()" [prefix]="prefix"></app-text-input>

            <hr class="fr-6">

            <app-diagnosis-select-input
                class="fr-2"
                [form]="finalForm"
                id="finalDiagnosisCode"
                [disabled]="!partOneFilled()"
                [label]="prefix + 'fields.finalDiagnosisCode'"
            ></app-diagnosis-select-input>
            <app-date-input class="fr-2" [form]="finalForm" id="incapacityEndDate" [showTime]="false"
                [prefix]="prefix" [disabled]="!partOneFilled()"></app-date-input>
            <app-date-input class="fr-2" [form]="finalForm" id="issueEndDate" [showTime]="false"
                [prefix]="prefix" [disabled]="!partOneFilled()"></app-date-input>

            <app-text-input class="fr-6" [form]="finalForm" id="decidingDoctor"
                [prefix]="prefix" [disabled]="!partOneFilled()"></app-text-input>

            <hr class="fr-6">

            <label class="font-bold fr-6">
                {{ 'sickNotes.detail.labels.confirmationOfAttendingDoctorForContinue' | translate }}
            </label>


            <app-date-input [form]="ptdpnForm" id="confirmationDurationDate" [showTime]="false"
                [prefix]="prefix" [disabled]="!partOneFilled()"></app-date-input>
            <app-date-input [form]="ptdpnForm" id="confirmationIssueDate" [showTime]="false"
                [prefix]="prefix" [disabled]="!partOneFilled()"></app-date-input>
            <app-text-input class="fr-2" [form]="ptdpnForm" id="confirmingDoctor" [prefix]="prefix"
                [disabled]="!partOneFilled()"></app-text-input>
            <app-date-input class="fr-2" [form]="ptdpnForm" id="controlDate" [showTime]="false"
                [prefix]="prefix"></app-date-input>

            <div class="flex justify-content-end fr-6">
                <app-button label="sickNotes.buttons.createTemporaryIncapacityForWorkConfirmation"
                    [disabled]="!partOneFilled()"
                    (clickEvent)="savePtdpn()"></app-button>
            </div>
        </div>
    </div>

    <div class="flex flex-1 align-items-center">
        <app-action-buttons
            [fullWidth]="true"
            [primaryButtonLabel]="form.value.correctiveFilling ? 'sickNotes.buttons.update' : 'sickNotes.buttons.create'"
            (primaryClickEvent)="saveAndSend()"
            (secondaryClickEvent)="close()"
        >
            <app-button icon="pi-history" label="sickNotes.buttons.history" severity="warn"
                (clickEvent)="historyModal($event)"></app-button>
            <app-button label="sickNotes.buttons.request" severity="secondary"
                (clickEvent)="requestModal($event)"></app-button>
            <app-button label="sickNotes.buttons.attendingDoctorReport" severity="secondary"
                (clickEvent)="reportModal($event)"></app-button>
        </app-action-buttons>
    </div>
</div>
